import { create } from "zustand";
import { api } from "@/lib/api";
import type { ReadModelDto } from "@package/types";
import type { AsyncState } from "./types";

interface ModelsState extends AsyncState {
  models: ReadModelDto[];
  selectedModelId: string;
}

interface ModelsActions {
  loadModels: () => Promise<void>;
  setSelectedModelId: (id: string) => void;
  reset: () => void;
}

type ModelsStore = ModelsState & ModelsActions;

export const useModelsStore = create<ModelsStore>()((set, get) => ({
  models: [],
  selectedModelId: "",
  isLoading: false,
  isLoaded: false,
  error: null,

  loadModels: async () => {
    if (get().isLoaded || get().isLoading) return;

    set({ isLoading: true, error: null });
    try {
      const data = await api.get<ReadModelDto[]>("/models");
      const defaultModel =
        data.find((model) => model.isActive && model.isDefault) ??
        data.find((model) => model.isActive);
      set({
        models: data,
        selectedModelId: defaultModel ? String(defaultModel.id) : "",
        isLoading: false,
        isLoaded: true
      });
    } catch (error) {
      set({ isLoading: false, error: (error as Error).message });
    }
  },

  setSelectedModelId: (id: string) => set({ selectedModelId: id }),

  reset: () =>
    set({
      models: [],
      selectedModelId: "",
      isLoading: false,
      isLoaded: false,
      error: null
    })
}));
